// Razorpay Checkout for the partner sign-up's first website bundle, on Ownezzy's own Razorpay account (like the admin
// panel's purchases: apps/admin/src/utils/razorpayCheckout.js). The server makes the partner account once the payment
// is confirmed.
import { isInternational } from '../shared/signup/usd';

const SCRIPT = 'https://checkout.razorpay.com/v1/checkout.js';
let loading = null;

const loadScript = () => {
  if (window.Razorpay) return Promise.resolve();
  if (!loading) {
    loading = new Promise((resolve, reject) => {
      const tag = document.createElement('script');
      tag.src = SCRIPT;
      tag.async = true;
      tag.onload = resolve;
      tag.onerror = () => {
        loading = null;
        reject(new Error('The payment window could not be loaded. Check your connection and try again.'));
      };
      document.body.appendChild(tag);
    });
  }
  return loading;
};

// The payment as the server sees it: { status, partner } (partner once paid)
export async function paymentStatus(paymentId, payToken) {
  const res = await fetch(`/api/billing/payments/${paymentId}`, { headers: { 'x-pay-token': payToken } });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.message || 'Could not check the payment.');
  return data.payment;
}

// Resolves to the payment once Razorpay reports back, or null if the window was closed without paying
export async function payWithRazorpay(checkout) {
  await loadScript();
  return new Promise((resolve) => {
    const rzp = new window.Razorpay({
      key: checkout.keyId,
      order_id: checkout.providerOrderId,
      amount: checkout.amountPaise,
      currency: 'INR',
      name: checkout.name,
      description: checkout.description,
      prefill: checkout.prefill,
      config: {
        display: {
          // UPI first, then cards, net banking and wallets; outside India cards, net banking and wallets come first, as UPI needs an Indian bank account
          blocks: { first: isInternational() ? { name: 'Card, net banking or wallet', instruments: [{ method: 'card' }, { method: 'netbanking' }, { method: 'wallet' }] } : { name: 'Pay by UPI', instruments: [{ method: 'upi' }] } },
          sequence: ['block.first'],
          preferences: { show_default_blocks: true },
        },
      },
      handler: async (res) => {
        try {
          const reply = await fetch(`/api/billing/payments/${checkout.paymentId}/confirm`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'x-pay-token': checkout.payToken },
            body: JSON.stringify({ paymentId: res.razorpay_payment_id, signature: res.razorpay_signature }),
          });
          resolve((await reply.json()).payment || { status: 'pending' });
        } catch {
          resolve({ status: 'pending' }); // the server's background check still applies the payment
        }
      },
      modal: { ondismiss: () => resolve(null), confirm_close: true },
    });
    rzp.open();
  });
}
